import { render } from "./LoadCustomerModal.vue?vue&type=template&id=2eb0ad6f&ts=true"
import script from "./LoadCustomerModal.vue?vue&type=script&lang=ts"
export * from "./LoadCustomerModal.vue?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__